import { getRoundTwo } from "src/helpers/decimal";
import { removeStoragePersistPagarAll, removeStoragePersistPagarById, setStoragePersistMontoPagar, setStoragePersistPagar, setStoragePersistPagarAll } from "src/helpers/localstorage";
import { postProcesarPago, putActualizacionDatosAcceso } from "src/service/APIService";
import { types } from "../types/types"
import { setAlert } from "./alert";
import { setCompletado } from "./ui";
// import { setAlert } from "./alert";
// import axios from "axios";
// import { postPolizaPagar } from "src/service/APIService";


const formatearPolizaPagar = (data, check = null) => {


    const polizasPagar = data.map((d) => ({
        ID: d.ID,
        IDTIPOPAGO: d.IDTIPOPAGO,
        NUMERO: d.NUMERO, //NUMERO DE POLIZA
        // tipopago: data.DESCRIPCION,
        PAGAR: getRoundTwo(d.PAGAR),
        CHECK: check || d.CHECK
    }));

    return polizasPagar;
}

// setear check all poliza
export const setAllPolizaAPagar = (poliza) => {

    return ({
        type: types.setAllPagarPoliza,
        payload: poliza
    });
}

export const setCheckAllPolizaAPagar = (todasPolizas) => {

    // extraer datos importantes
    let polizasPagar = formatearPolizaPagar(todasPolizas, true);
    // seter en localStorage
    setStoragePersistPagarAll(polizasPagar);

    return ({
        type: types.setCheckAllPagarPoliza
    });
}

export const setCheckPolizaAPagar = (id, datos) => {


    // extraer datos importantes
    let polizasPagar = formatearPolizaPagar(datos, true);

    console.log(polizasPagar);

    // seter en localStorage
    setStoragePersistPagar(polizasPagar)

    // state
    return ({
        type: types.setCheckPagarPoliza,
        payload: id
    });
}

// remove poliza a pagar
export const removeAllPolizaAPagar = () => {

    return ({
        type: types.removeAllPagarPoliza
    })
};

export const removeCheckAllPolizaAPagar = () => {

    // remove all poliza pagar
    removeStoragePersistPagarAll();

    return ({ type: types.removeCheckAllPagarPoliza });
};


export const removeCheckPolizaAPagar = (id, datos) => {

    // remover en localStorage BY ID
    removeStoragePersistPagarById(id);

    return ({
        type: types.removeCheckPagarPoliza,
        payload: id
    });
};


// ** Actualizacion de datos de acceso

export const submitDatosAcceso = ({
    idaccion,
    paso = 0,
    email = ''
}) => {

    return dispatch => {
        putActualizacionDatosAcceso({
            idaccion,
            paso,
            email
        })
            .then(
                data => {
                    console.log(data);
                }
            )
    }

}

//** Actualizar el monto a pagar
export const setHandleChangePago = (pago, id) => {
    // localstorage
    setStoragePersistMontoPagar(pago, id);

    return ({
        type: types.setChangePago,
        payload: {
            pago,
            id
        }
    })
};

// ** escuchar cambios email
export const setInputEmail = (values) => {
    const { value } = values;

    return ({
        type: types.setHandleChangeEmail,
        payload: value
    });
}


// ** forma de pago
export const setFormaPago = (formapago) => {
    return ({
        type: types.setFormaPago,
        payload: formapago
    });
}

// ? TARJETA DE CREDITO 
export const startProcesoTarjetaCredito = (data, steps) => {

    return (dispatch) => {
        if (!data.error) {
            const { step, stepForward } = steps;
            dispatch(setResponseTarjetaCredito(data));

            // console.log(data);
            if (data.status === 'APPROVED' && data.statusInterno === true) {
                dispatch(setCompletado('S'))
            } else {
                dispatch(setCompletado('N'))
            }
            stepForward(step);

        } else {
            const { message } = data;
            dispatch(setAlert({ color: 'danger', message: message?.descripcion || 'error generico' }));
        }
        dispatch(finishLoadingResponseProcesoPago());
    }

}

// ? CLAVE 
export const startProcesoClave = (data, steps) => {

    return (dispatch) => {
        if (!data.error) {

            console.log("Entro en el prroceso de clave")
            const { step, stepForward } = steps;
            dispatch(setResponseClave(data));

            // console.log(data);
            if (data.status === 'PENDING') {

                // setear estado de pago en espera de respuesta

                // redirrecionar a otra pagina
                window.location.replace(data.processUrl);
                // esperar unos segundos para que el usuario pueda ver el proceso de pago
                setTimeout(() => {
                    dispatch(setCompletado('E'))
                }, 50000);


            } else {
                dispatch(setCompletado('N'))
            }
            // crear una pausea para que el usuario pueda ver el proceso de pago

            stepForward(step);

        } else {
            const { message } = data;
            dispatch(setAlert({ color: 'danger', message: message?.descripcion || 'error generico' }));
        }
        dispatch(finishLoadingResponseProcesoPago());
    }

}


// ** escuchar cambios en los datos de la  tarjeta de credito
export const handleInputChangeTarjetaCredito = (values) => {

    const { name, value } = values;
    return ({
        type: types.setChangeTarjetaCredito,
        payload: { name, value }
    })

}



//* set response pay
export const setResponseTarjetaCredito = (data) => ({
    type: types.setResponseTarjetaCredito,
    payload: data
})

export const setResponseClave = (data) => ({
    type: types.setResponseClave,
    payload: data
})

// export const startLoadingResponseTarjetaCredito = () => ({
//     type: types.startloadingResponseTarjetaCredito
// });

// export const finishLoadingResponseTarjetaCredito = () => ({
//     type: types.finishloadingResponseTarjetaCredito
// });

// set datos de poliza a pagar en localstorage
export const submitPolizasPagar = (datos) => {

    return (dispatch) => {
        let polizasPagar = formatearPolizaPagar(datos, true);
        // console.log()
        // setStoragePersist('pagar', JSON.stringify(polizasPagar))
        // postPolizaPagar(polizasPagar)
        //     .then(
        //         data => {
        //             if (!data.error) {                    
        //                 console.log(data);
        //             } else {

        //             }
        //         }
        //     )

    }

}

// ?? YAPPY
export const startProcesoYappy = (data, steps) => {

    return (dispatch) => {
        console.log("data yappy", data);

        const { step, stepForward } = steps;

        if (!data.error) {
            const { code } = data.status;
            if (code === '0000') {
                dispatch(setCompletado('E'))
                stepForward(step);
            } else {
                dispatch(setAlert({ color: 'danger', message: data.description }));
            }
        }


        dispatch(finishLoadingResponseProcesoPago());
    }

}

// ** escuchar cambios en datos de yappy
export const handleInputChangeYappy = (values) => {
    const { name, value } = values;
    return ({
        type: types.setHandleChangeYappy,
        payload: { name, value }
    })

}

export const submitProcesarPago = (pays, steps) => {

    return dispatch => {

        const { idorigen, email, pagos, yappy, tarjetaCredito, clave } = pays;
        const datosPagos = pagos.filter(({ CHECK }) => CHECK === true)
            .map((value) => ({
                idtipopago: value.IDTIPOPAGO,
                poliza: value.NUMERO,
                monto: getRoundTwo(value.PAGAR)
            }));

        const formatoData = {
            idorigen,
            email: email || '',
            pagos: datosPagos || [],
            yappy: yappy || {},
            tarjetaCredito: tarjetaCredito || {},
            clave: clave || {}
        };

        dispatch(startLoadingResponseProcesoPago());
        postProcesarPago(formatoData)
            .then(data => {
                if (!data.error) {
                    dispatch(startProcesoPago(data, idorigen, steps));
                } else {
                    // Yappy
                    if (parseFloat(idorigen) === parseFloat(process.env.REACT_APP_ID_ORIGEN_YAPPY) && data.status === 400) {
                        dispatch(setAlert({ color: 'danger', message: data?.message || 'error API' }));

                    }

                    // Tarjeta de crédito
                    if (parseFloat(idorigen) === parseFloat(process.env.REACT_APP_ID_ORIGEN_TARJETA_CREDITO) && data.message.status === 400) {
                        dispatch(setAlert({ color: 'danger', message: data?.message.descripcion || 'error generico' }));
                    }


                    //Clave
                    if (parseFloat(idorigen) === parseFloat(process.env.REACT_APP_ID_ORIGEN_CLAVE) && data.message.status === 400) {
                        dispatch(setAlert({ color: 'danger', message: data?.message.descripcion || 'error generico' }));
                    }

                    dispatch(finishLoadingResponseProcesoPago());
                }
            });
    }
}

export const startProcesoPago = (data, idorigen, steps) => {

    return dispatch => {
        switch (idorigen) {

            // yappy
            case parseFloat(process.env.REACT_APP_ID_ORIGEN_YAPPY):
                return dispatch(startProcesoYappy(data, steps));
            //tarjeta de credito
            case parseFloat(process.env.REACT_APP_ID_ORIGEN_TARJETA_CREDITO):
                return dispatch(startProcesoTarjetaCredito(data, steps));
            //clave
            case parseFloat(process.env.REACT_APP_ID_ORIGEN_CLAVE):
                return dispatch(startProcesoClave(data, steps));
            // otros
            default:
                dispatch(finishLoadingResponseProcesoPago());
                return false;
        }
    }
}

export const startLoadingResponseProcesoPago = () => ({
    type: types.startloadingResponseProcesoPago
});

export const finishLoadingResponseProcesoPago = () => ({
    type: types.finishloadingResponseProcesoPago
});
